import "./assets/main.css";

import { createApp } from "vue";
import { createPinia } from "pinia";

import i18n from "./i18n";
import { Field, Form, ErrorMessage, defineRule, configure } from "vee-validate";
import AllRules from "@vee-validate/rules";
import { localize, setLocale } from "@vee-validate/i18n";
import zhTW from "@vee-validate/i18n/dist/locale/zh_TW.json";
import zhCH from "@vee-validate/i18n/dist/locale/zh_CN.json";
import viVN from "@vee-validate/i18n/dist/locale/vi.json";
import euUS from "@vee-validate/i18n/dist/locale/en.json";
import jaJP from "@vee-validate/i18n/dist/locale/ja.json";
import thTA from "@vee-validate/i18n/dist/locale/th.json";
import App from "./App.vue";
import router from "./router";
import mitt from "mitt";
//@ts-ignore
import { imgsPreloader } from "./assets/image/imgPreloader.js";
//@ts-ignore
import imgPreloaderList from "./assets/image/imgPreloaderList.js";
import { createHead } from '@vueuse/head'

if (
  import.meta.env.VITE_CONFIG_MODE == "TCE"
) {
  import("./assets/TCE.css").then(() => { });
} else if (
  import.meta.env.VITE_CONFIG_MODE == "ICC"
) {
  import("./assets/ICC.css").then(() => { });
} else if (
  import.meta.env.VITE_CONFIG_MODE == "RM"
) {
  import("./assets/RM.css").then(() => { });
} else if (
  import.meta.env.VITE_CONFIG_MODE == "YZXtest" ||
  import.meta.env.VITE_CONFIG_MODE == "YZX"
) {
  import("./assets/YZXstyle.css").then(() => { });
} else if (
  import.meta.env.VITE_CONFIG_MODE == "MTtest" ||
  import.meta.env.VITE_CONFIG_MODE == "MT"
) {
  import("./assets/MTstyle.css").then(() => { });
} else if (
  import.meta.env.VITE_CONFIG_MODE == "ICVtest" ||
  import.meta.env.VITE_CONFIG_MODE == "ICV"
) {
  import("./assets/ICVstyle.css").then(() => { });
} else if (
  import.meta.env.VITE_CONFIG_MODE == "CYFtest" ||
  import.meta.env.VITE_CONFIG_MODE == "CYF"
) {
  import("./assets/CYFstyle.css").then(() => { });
} else {
  import("./assets/style.css").then(() => { });
}

// 導入圖片預載入方法以及圖片列表
imgsPreloader(imgPreloaderList);

Object.keys(AllRules).forEach((rule) => {
  defineRule(rule, AllRules[rule]);
});

configure({
  generateMessage: localize({
    "zh-TW": zhTW,
    "zh-CH": zhCH,
    "vi-VN": viVN,
    "eu-US": euUS,
    "ja-JP": jaJP,
    "th-TA": thTA,
  }),
  validateOnInput: true,
});
setLocale("zh_TW");
const app = createApp(App);
const head = createHead()

// 動態圖片（API 回傳的網址）安全綁定：
// 1. 網址為空（資料尚未就緒）時不顯示破圖框，避免出現 <img src="">
// 2. 載入失敗（如 CDN 瞬時失敗）時自動隱藏破圖
// 3. 網址更新時重新套用
function applySafeSrc(el: HTMLImageElement, val: unknown) {
  if (!val) {
    el.style.visibility = "hidden";
    el.removeAttribute("src");
    return;
  }
  el.style.visibility = "visible";
  el.onerror = () => {
    el.style.visibility = "hidden";
  };
  el.src = String(val);
}

app.directive("safe-src", {
  mounted(el, binding) {
    applySafeSrc(el, binding.value);
  },
  updated(el, binding) {
    if (binding.value !== binding.oldValue) applySafeSrc(el, binding.value);
  },
});

app.directive("img-src", {
  mounted(el, binding) {
    const mode = import.meta.env.VITE_CONFIG_MODE;
    const type = localStorage.getItem("Language");
    // if (binding.value.includes("assets")) {
    //   let typefile = "tw";
    //   if (type === "zh-TW") {
    //     typefile = `assets/tw`;
    //   }
    //   if (type === "en-US") {
    //     typefile = `assets/en`;
    //   }
    //   if (type === "vi-VN") {
    //     typefile = `assets/vn`;
    //   }
    //   if (type === "zh-CH") {
    //     typefile = `assets/cn`;
    //   }
    //   if (type === "ja-JP") {
    //     typefile = "/jp";
    //   }
    //   el.src = binding.value.replace(/assets\/tw/g, typefile);
    // } else {
    let typefile = "tw";
    if (type === "zh-TW") {
      typefile = "/tw";
    }
    if (type === "en-US") {
      typefile = "/en";
    }
    if (type === "vi-VN") {
      typefile = "/vn";
    }
    if (type === "zh-CH") {
      typefile = "/cn";
    }
    if (type === "ja-JP") {
      typefile = "/jp";
    }
    if (type === "th-TA") {
      typefile = "/ta";
    }
    // console.log(type, binding, "img-src");
    el.src = binding.value.replace(/(?=\/memberFunction)/, typefile);
    // }
  },
});

app.use(i18n);
app.component("VField", Field);
app.component("VForm", Form);
app.component("ErrorMessage", ErrorMessage);
app.use(createPinia());
app.config.globalProperties.$mitt = mitt();
app.use(router);
app.use(head)
app.mount("#app");
